import React from 'react'
import Slider from 'react-slick'
import cardBackImage from '../../images/back-card.svg'
import { S3_BUCKET_ENDPOINT_FAST_GAMES } from 'constants/index'

const HiloFairnessModalResult = (roundHashDetails) => {
  const betStates = roundHashDetails.shuffledDeck

  const cardImgPaths = `${S3_BUCKET_ENDPOINT_FAST_GAMES}/pixiAssets/cards`

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  }

  return (
    <div className='card-history m-4'>
      <div className='card-slider-hilo'>
        {betStates && betStates.length > 0
          ? (
            <Slider {...settings}>
              {betStates?.slice()?.map((card, index) => ( // used to not mutate and to reverse the array
                <div key={card.id}>
                  <div className='card m-1'>
                    <img
                      className='history-card'
                      src={`${cardImgPaths}/${card}.webp`}
                    // src={cardBackImage}
                      alt='history-card'
                    />
                  </div>
                </div>
              ))}
            </Slider>
            )
          : (
            <div className='d-flex justify-content-between cards-section gx-0'>
              {[...Array(5)].map((_, index) => (
                <div className='cards-col' key={index}>
                  <div className='card-image-cover animated flip-front-card m-1'>
                    <img
                      className='card-image img-fluid'
                      src={cardBackImage}
                      alt='player-card'
                    />
                  </div>
                </div>
              ))}
            </div>
            )}

      </div>
    </div>
  )
}

export default HiloFairnessModalResult
